function errorMorpheme(row) {
  const text = row.sentence_text;
  const verb = row.sentence_verb
  const roman = row.roman_sentence_text
  
  const verbFirst = verb && verb.split(",")[0] === "1" && text[text.length-1] !== "?"
  const letsPlease =
    text.toLowerCase().indexOf("let's") !== -1 ||
    text.toLowerCase().indexOf("please") !== -1;

  const whatHow = 
    (text.split(" ")[0] === "What" || text.split(" ")[0] === "How") &&
    text[text.length - 1] === "!";

  const commaNext = text.indexOf(",") !== -1 && verb.split(",").indexOf(String(text.indexOf(",")+3)) !== -1

  const morpheme =
    `${row.sentence_subject},${row.sentence_verb},${row.sentence_direct_object},${row.sentence_indirect_object},${row.sentence_complement},${row.sentence_adverb},${row.sentence_etc}`.split(
      ","
    );
      const errMorpheme = morpheme.filter((el) => el !== "null");

  if (
    text &&
    text[text.length - 1] !== "." &&
    text[text.length - 1] !== "!" &&
    text[text.length - 1] !== "?"
  ) {
    return "기호";
  } else if (text.length - 1 !== errMorpheme.length) {
    return "숫자";
  } else if (text.split(" ").length !== roman?.split(" ").length) {
    return "발음"
  } else if (verbFirst || letsPlease || commaNext) { //동사로 시작하거나 let's 또는 please가 포함된 문장에서는 주어가 없어도 된다.
    if (
      (row.ContentSettingSentencePattern_code === "1" &&
        (row.sentence_verb === null ||
          row.sentence_direct_object !== null ||
          row.sentence_indirect_object !== null ||
          row.sentence_complement !== null)) ||
      (row.ContentSettingSentencePattern_code === "2" &&
        (row.sentence_verb === null ||
          row.sentence_direct_object !== null ||
          row.sentence_indirect_object !== null ||
          row.sentence_complement === null)) ||
      (row.ContentSettingSentencePattern_code === "3" &&
        (row.sentence_verb === null ||
          row.sentence_direct_object === null ||
          row.sentence_indirect_object !== null ||
          row.sentence_complement !== null)) ||
      (row.ContentSettingSentencePattern_code === "4" &&
        (row.sentence_verb === null ||
          row.sentence_direct_object === null ||
          row.sentence_indirect_object === null ||
          row.sentence_complement !== null)) ||
      (row.ContentSettingSentencePattern_code === "5" &&
        (row.sentence_verb === null ||
          row.sentence_direct_object === null ||
          row.sentence_indirect_object !== null ||
          row.sentence_complement === null))
    ) {
      return "성분";
    } else {
      return null;
    }
  } else if (whatHow) {
    if(
        row.ContentSettingSentencePattern_code === "1" &&
        (row.sentence_direct_object !== null ||
        row.sentence_indirect_object !== null ||
        row.sentence_complement !== null)
    ) {
        return "성분"
    } else if (
      row.ContentSettingSentencePattern_code === "2" &&
        (row.sentence_direct_object !== null ||
        row.sentence_indirect_object !== null ||
        row.sentence_complement === null)
    ) {
      return "성분"
    } else if(
      row.ContentSettingSentencePattern_code !== "1" && row.ContentSettingSentencePattern_code !== "2"
    ) {
      return "성분"
    } else {
        return null
    }
  } else if (
    (row.ContentSettingSentencePattern_code === "1" &&
      (row.sentence_subject === null ||
        row.sentence_verb === null ||
        row.sentence_direct_object !== null ||
        row.sentence_indirect_object !== null ||
        row.sentence_complement !== null)) ||
    (row.ContentSettingSentencePattern_code === "2" &&
      (row.sentence_subject === null ||
        row.sentence_verb === null ||
        row.sentence_direct_object !== null ||
        row.sentence_indirect_object !== null ||
        row.sentence_complement === null)) ||
    (row.ContentSettingSentencePattern_code === "3" &&
      (row.sentence_subject === null ||
        row.sentence_verb === null ||
        row.sentence_direct_object === null ||
        row.sentence_indirect_object !== null ||
        row.sentence_complement !== null)) ||
    (row.ContentSettingSentencePattern_code === "4" &&
      (row.sentence_subject === null ||
        row.sentence_verb === null ||
        row.sentence_direct_object === null ||
        row.sentence_indirect_object === null ||
        row.sentence_complement !== null)) ||
    (row.ContentSettingSentencePattern_code === "5" &&
      (row.sentence_subject === null ||
        row.sentence_verb === null ||
        row.sentence_direct_object === null ||
        row.sentence_indirect_object !== null ||
        row.sentence_complement === null))
  ) {
    return "성분";
  } else {
    return null;
  }
}

export default errorMorpheme;
